import React, { useState, useEffect, useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import slugify from 'slugify'
import { useSelector, useDispatch } from 'react-redux'
import { usePromiseTracker } from 'react-promise-tracker'
import appContext from '../../../context/appContext'
import history from '../../../history'

import Loader from '../../Loader/Loader'
import {
  ScreenContainer,
  MainHeader,
  MainContentContainer,
  MainSubHeader,
  VerticalDivider,
  MealIngredientName,
  MealIngredientKcalValue,
  MealIngredientWeightValue,
  MealIngredientRow,
  MealsMainHeader,
  BigHeader,
} from '../Shared/SharedStyledComponents'
import { TopColorBar } from '../../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen.jsx'
import BackButton from '../../shared/BackButton'
import NavigationBar from '../../NavigationBar/NavigationBar'
import DemoModeAnnouncement from '../../DemoModeAnnouncement/DemoModeAnnouncement.jsx'

import {
  MealDetails,
  MealDetailsTileContainer,
  CartButton,
  CartButtonContainer,
  CartButtonText,
} from './MealDetailsScreenStyles'

import { DietStandardButton } from '../Shared/SharedStyledComponents'

import MealDetailTile from './subComponents/MealDetailsTile/MealDetailsTile'
import MealRecipeTile from './subComponents/MealRecipeTile/MealRecipeTile'
import MealIngredientsTile from './subComponents/MealIngredientsListTile/MealIngredientsTile'
import Navigation from '../../Challenges/components/Navigation/Navigation'
import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericColumn from '../../../GenericComponents/GenericColumn'

import { MealsContainer, ChangeDietBox } from '../style/DietStyle'
import GenericButton from '../../../GenericComponents/GenericButton'
import ChangeDietIcon from '../../../assets/REDESIGN_Assets/Diet/change-diet-icon.svg'
import DietCartIcon from '../../../assets/REDESIGN_Assets/Diet/diet-cart-icon.svg'

import ProductIcon from '../../../assets/REDESIGN_Assets/Diet/product-icon.svg'
import AddproductToCartIcon from '../../../assets/REDESIGN_Assets/Diet/add-product-to-cart-icon.svg'
import GenericMobileTopNavigation from '../../../GenericComponents/GenericMobileTopNavigation'
import AppContext from '../../../context/appContext'
import AddproductIcon from '../../../assets/REDESIGN_Assets/Diet/add-meal-icon.svg'
// import { changeDiet } from '../DietMainScreen/DietMainScreenContainer'

interface MealsDeatailsScreenProps {
  meal: any
  addMeal: any
  diet: any
  chosenDate: any
  addIngredientToCart: any
  ingredientInCart: any
  changeDiet: any
  challengeMode: boolean
}

const MealsDeatailsScreen: React.FC<MealsDeatailsScreenProps> = ({
  meal,
  addMeal,
  diet,
  chosenDate,
  addIngredientToCart,
  ingredientInCart,
  changeDiet,
  challengeMode
}) => {
  let history = useHistory()
  const location = useLocation()
  const dietType = location.state.dietType
  const mealName = location.state.chosedMeal
  const appContext = useContext(AppContext)

  const [shouldAnimate, triggerAnimation] = useState(false)
  const [itemsInBasket, setItemsInBasket] = useState([])
  const { promiseInProgress } = usePromiseTracker()

  const dispatch = useDispatch()

  const setAnimation = () => {
    triggerAnimation(true)

    setTimeout(() => {
      triggerAnimation(false)
    }, 250)
  }
  const dietAppStore = useSelector((state: any) => state.diet)
  useEffect(() => {
    setAnimation()
    setItemsInBasket(dietAppStore)
  }, [dietAppStore])

  const goToMealDetails = (chosedMeal: string) => {
    history.push({
      pathname: `/dieta/szczegoly-posilku/${chosenDate}/${slugify(chosedMeal)}`,
      state: { dietType: dietType, chosedMeal: chosedMeal, challengeMode: challengeMode },
    })
  }

  const goToShoppingList = () => {
    history.push({
      pathname: `/dieta/${chosenDate}/lista-zakupow/`,
      state: { chosenDate: chosenDate, challengeMode: challengeMode },
    })
  }

  return (
    <GenericBackgroundLayer
      className={`${appContext.appState.theme == 'light' ? 'light' : 'standard'
        } diet-meal-details`}
      fDir="column"
      justify="flex-start"
    >
      {/* <TopColorBar relative>
        <BackButton place={'Szczegóły posiłku'} specialLocation={'/dieta'} />
      </TopColorBar> */}
      {challengeMode ? <Navigation /> : <NavigationBar
        isPlayerView={false}
        backButtonAction={() => history.push('/dieta')}
      />}
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          dietCartClick={() => goToShoppingList()}
          handleClick={() => challengeMode ? history.push({ pathname: '/dieta', state: { challengeMode: challengeMode } }) : history.push('/dieta')}
        />
      )}

      <GenericMainCard
        flexDir={'column'}
        width={isMobile ? '95%' : '60%'}
        className="standard"
        margin={'3% 0 0 0'}
      >
        <GenericRow
          width={isMobile ? '90%' : '80%'}
          flexDir={isMobile ? 'column' : 'row'}
          justify="flex-start"
          margin={'0 0 5% 0'}
          align={isMobile ? 'center' : 'baseline'}
        >
          <GenericTextSpan fSize={isMobile ? '2rem' : '1.4rem'}>
            {diet && diet.diet_name}
          </GenericTextSpan>
          <ChangeDietBox onClick={changeDiet}>
            <GenericTextSpan
              fSize={isMobile ? '1.3rem' : '0.9rem'}
              margin={'3% 2% 0% 5%'}
            >
              Zmień dietę
            </GenericTextSpan>
            <GenericIcon
              src={ChangeDietIcon}
              width={isMobile ? '3.5vw' : '1.2vw'}
              height={isMobile ? '3.5vw' : '1.2vw'}
              margin={'3% 2% 0% 3%'}
            ></GenericIcon>
          </ChangeDietBox>
          {!isMobile && (
            <GenericIcon
              className={'button-style'}
              src={DietCartIcon}
              width={'2.5vw'}
              height={'1.5vw'}
              onClick={() => goToShoppingList()}
            ></GenericIcon>
          )}
        </GenericRow>

        <MealsContainer className={'no-overflow '}>
          <GenericRow width={'100%'}>
            <GenericTextSpan
              fSize={isMobile ? '1.8rem' : '1.4rem'}
              margin={'0 0 1% 0'}
            >
              Szczegóły posiłku
            </GenericTextSpan>
          </GenericRow>

          <GenericRow width={'100%'}>
            <GenericButton
              className="standard"
              justify="center"
              width={isMobile ? '90%' : '50%'}
              margin={'1% 0 4% 0'}
              onClick={() => addMeal(meal.id)}
            >
              Dodaj posiłek{' '}
            </GenericButton>
          </GenericRow>

          <GenericRow
            width={'100%'}
            margin={'3% 0 0 0'}
            align={'flex-start'}
            wrap={isMobile ? 'wrap' : 'unset'}
          >
            <GenericColumn
              className={isMobile && 'diet-meal-details-left-col'}
              width={isMobile ? '100%' : '50%'}
            >
              <GenericRow osition={'relative'}>
                <GenericTextSpan
                  fSize={isMobile ? '2.2rem' : '1.4rem'}
                  fWeight="bold"
                  width={'60%'}
                >
                  {meal && meal.name}
                </GenericTextSpan>
                {/* <GenericIcon
                  className="button-style"
                  width={isMobile ? '1.8rem' : '1.8vw'}
                  height={isMobile ? '1.8rem' : '1.8vw'}
                  src={AddproductIcon}
                  position="absolute"
                  onClick={() => addMeal(meal.id)}
                  right={isMobile ? '15%' : '0'}
                ></GenericIcon> */}
              </GenericRow>

              <GenericRow justify="center" align="center">
                <GenericTextSpan
                  fSize={isMobile ? '2.4rem' : '2rem'}
                  fWeight="normal"
                  margin={isMobile ? '5% 0 0 5%' : '5% 0 0 0'}
                  className="color-green"
                >
                  {meal && meal.calories.amount}
                </GenericTextSpan>
                <GenericTextSpan
                  fSize={'1rem'}
                  fWeight="normal"
                  margin={'5% 0 0 5%'}
                >
                  kcal
                </GenericTextSpan>
              </GenericRow>

              <GenericRow
                justify="space-between"
                align="center"
                margin={'5% 0 0 0'}
              >
                <GenericColumn>
                  <GenericTextSpan
                    fSize={isMobile ? '1.5rem' : '1rem'}
                    fWeight="bold"
                  >
                    Białko
                  </GenericTextSpan>
                  <GenericRow>
                    <GenericTextSpan
                      fSize={isMobile ? '1.7rem' : '1rem'}
                      fWeight="normal"
                      margin={'5% 0 0 0'}
                      className="color-green"
                    >
                      {meal && meal.calories.protein}
                    </GenericTextSpan>
                    <GenericTextSpan
                      fSize={isMobile ? '1.4rem' : '1rem'}
                      fWeight="normal"
                      margin={'5% 0 0 0'}
                    >
                      g
                    </GenericTextSpan>
                  </GenericRow>
                </GenericColumn>
                <GenericColumn>
                  <GenericTextSpan
                    fSize={isMobile ? '1.5rem' : '1rem'}
                    fWeight="bold"
                  >
                    Węglowodany
                  </GenericTextSpan>
                  <GenericRow>
                    <GenericTextSpan
                      fSize={isMobile ? '1.7rem' : '1rem'}
                      fWeight="normal"
                      margin={'5% 0 0 0'}
                      className="color-green"
                    >
                      {meal && meal.calories.carbs}
                    </GenericTextSpan>
                    <GenericTextSpan
                      fSize={isMobile ? '1.4rem' : '1rem'}
                      fWeight="normal"
                      margin={'5% 0 0 0'}
                    >
                      g
                    </GenericTextSpan>
                  </GenericRow>
                </GenericColumn>
                <GenericColumn>
                  <GenericTextSpan
                    fSize={isMobile ? '1.5rem' : '1rem'}
                    fWeight="bold"
                  >
                    Tłuszcz
                  </GenericTextSpan>
                  <GenericRow>
                    <GenericTextSpan
                      fSize={isMobile ? '1.7rem' : '1rem'}
                      fWeight="normal"
                      margin={'5% 0 0 0'}
                      className="color-green"
                    >
                      {meal && meal.calories.fat}
                    </GenericTextSpan>
                    <GenericTextSpan
                      fSize={isMobile ? '1.4rem' : '1rem'}
                      fWeight="normal"
                      margin={'5% 0 0 0'}
                    >
                      g
                    </GenericTextSpan>
                  </GenericRow>
                </GenericColumn>
              </GenericRow>

              <GenericColumn
                className="  diet-items-overflow"
                width={'80%'}
                margin={isMobile ? '5% 0 0 0' : '15% 0 0 0'}
                justify={'flex-start'}
              >
                {meal &&
                  meal.ingredients_detail.map((ingredient: any) => (
                    <GenericRow
                      justify="flex-start"
                      align={'flex-start'}
                      margin={'2% 0 0 0'}
                    >
                      <GenericColumn>
                        <GenericRow justify="flex-start" margin={'0 0 1% 0'}>
                          {/* <GenericIcon
                            width={isMobile ? '1rem' : '0.7vw'}
                            height={isMobile ? '1rem' : '0.7vw'}
                            src={ProductIcon}
                            margin={'0 5% 0 0'}
                          /> */}
                          <GenericTextSpan
                            fSize={isMobile ? '1.2rem' : '0.9rem'}
                            tAlign="left"
                            fWeight={'bold'}
                          >
                            {ingredient.ingredient}
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow
                          justify="flex-start"
                          margin={'0 0 3% 15%'}
                          opacity={'0.9'}
                        >
                          <GenericTextSpan
                            fSize={isMobile ? '1rem' : '0.8rem'}
                            margin={'0 0 0 4%'}
                          >
                            {ingredient.amount}
                          </GenericTextSpan>
                          <GenericTextSpan
                            fSize={isMobile ? '1rem' : '0.8rem'}
                            margin={'0 0 0 2%'}
                          >
                            {ingredient.unit}
                          </GenericTextSpan>
                          <GenericTextSpan
                            fSize={isMobile ? '1rem' : '0.8rem'}
                            margin={'0 0 0 2%'}
                          >{`(${ingredient.weight}g)`}</GenericTextSpan>
                        </GenericRow>
                      </GenericColumn>
                      <GenericIcon
                        onClick={() => addIngredientToCart(ingredient.id)}
                        className="button-style"
                        width={isMobile ? '1.5rem' : '1.4vw'}
                        height={isMobile ? '1.5rem' : '1.4vw'}
                        src={AddproductToCartIcon}
                        margin={'0 5% 0 0'}
                      />
                    </GenericRow>
                  ))}
              </GenericColumn>
            </GenericColumn>

            <GenericColumn width={isMobile ? '100%' : '50%'} padding={'0 4%'}>
              <GenericRow
                justify={isMobile ? 'center' : 'flex-start'}
                margin={isMobile ? '4% 0 0 0' : 'unset'}
              >
                <GenericTextSpan
                  fSize={isMobile ? '1.8rem' : '1rem'}
                  margin={'1% 0 0 0'}
                >
                  Sposób przygotowania
                </GenericTextSpan>
              </GenericRow>

              <GenericRow justify="flex-start" margin={'3% 0 0 0'}>
                <GenericColumn align={'flex-start'} justify="flex-start">
                  {meal &&
                    meal.recipe &&
                    meal.recipe.recipe.map((recipe: any, i: number) => (
                      <GenericRow
                        justify="flex-start"
                        align="flex-start"
                        margin={'3% 0%'}
                      >
                        <GenericTextSpan
                          fSize={isMobile ? '1.2rem' : '0.85rem'}
                          fWeight="bold"
                          margin={'0% 5% 0 0'}
                        >
                          {recipe.step_number}
                        </GenericTextSpan>
                        <GenericTextSpan
                          fSize={isMobile ? '1.2rem' : '0.85rem'}
                          fWeight="normal"
                          tAlign={'left'}
                        >
                          {recipe.text}
                        </GenericTextSpan>
                      </GenericRow>
                    ))}
                </GenericColumn>
              </GenericRow>
            </GenericColumn>
          </GenericRow>

          {/* <GenericRow width={'100%'}>
            <GenericButton
              className="standard"
              justify="center"
              width={'50%'}
              margin={'5% 0 0 0'}
              onClick={() => addMeal(meal.id)}
            >
              Dodaj posiłek{' '}
            </GenericButton>
          </GenericRow> */}
        </MealsContainer>
      </GenericMainCard>
      {/* <MainHeader>Diety</MainHeader>
      <MainSubHeader>{diet && diet.diet_name}</MainSubHeader>
      <DietStandardButton
        margin={'10px auto'}
        color={'white'}
        backgroundColor="blueviolet"
        onClick={changeDiet}
      >
        Zmień dietę
      </DietStandardButton>
      <MainContentContainer
        padding={isMobile ? '2vh 1vw' : '5vh 3vw'}
        marginTop={isMobile ? '1vh' : '5vh'}
        justify={'center'}
      >
        <MealsMainHeader>Szczegóły posiłku</MealsMainHeader>
        <BigHeader margin={isMobile ? '20px 0 10px 0' : '20px 0 30px 0'}>
          {meal && meal.name}
        </BigHeader>

        <MealDetails>
          <MealDetailsTileContainer>
            <MealDetailTile meal={meal} addMeal={addMeal} />
          </MealDetailsTileContainer>

          <VerticalDivider />

          <MealDetailsTileContainer>
            <MealIngredientsTile
              addIngredientToCart={addIngredientToCart}
              ingredientInCart={ingredientInCart}
              meal={meal}
            />
          </MealDetailsTileContainer>

          <VerticalDivider />

          <MealDetailsTileContainer>
            <MealRecipeTile meal={meal} />
          </MealDetailsTileContainer>
        </MealDetails>

        <CartButtonContainer onClick={goToShoppingList}>
          <CartButtonText>{!isMobile ? 'Koszyk' : ''}</CartButtonText>

          <CartButton
            className={shouldAnimate && 'animate'}
            // className="animate"
            hasCartSomeItems={dietAppStore.hasOwnProperty('diet')}
          ></CartButton>
        </CartButtonContainer>
        {isDemoAccount && <DemoModeAnnouncement />}
      </MainContentContainer>
      {promiseInProgress && <Loader />} */}
    </GenericBackgroundLayer>
  )
}

export default MealsDeatailsScreen
